<template>
  <svg width="13px" height="8px" viewBox="0 0 13 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs></defs>
    <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="global-arrow" transform="translate(-10.000000, -12.000000)" :fill='color'>
        <g id="dropdown-arrow" transform="translate(10.000000, 12.000000)">
          <polygon id="dropdown_arrow" points="6.31 4.72 11.37 0 13 1.87 6.31 8 0 1.87 1.63 0"></polygon>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'dropdown-arrow',
    props: {
      color: {
        default: '#A1A9B3'
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
</style>
